// extracted by mini-css-extract-plugin
export var card = "officialgoods-module--card--59d87";
export var cardDesc = "officialgoods-module--cardDesc--4513c";
export var cardTitle = "officialgoods-module--cardTitle--5dc99";
export var extIcon = "officialgoods-module--extIcon--38bcb";
export var grid = "officialgoods-module--grid--933a2";
export var header = "officialgoods-module--header--99340";
export var iconCircle = "officialgoods-module--iconCircle--77661";
export var leadText = "officialgoods-module--leadText--a66d0";
export var line = "officialgoods-module--line--77330";
export var mainTitle = "officialgoods-module--mainTitle--05348";
export var subTitle = "officialgoods-module--subTitle--34440";
export var suzuri = "officialgoods-module--suzuri--06df4";
export var wrapper = "officialgoods-module--wrapper--0eab3";